import { render } from "./createuser_page.vue?vue&type=template&id=f8dd8c72&scoped=true"
import script from "./createuser_page.vue?vue&type=script&lang=js"
export * from "./createuser_page.vue?vue&type=script&lang=js"

import "./createuser_page.vue?vue&type=style&index=0&id=f8dd8c72&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8dd8c72"]])

export default __exports__